module.exports = __webpack_public_path__ + "media/my_images/vision/SVG/2021-cb8a40119c2f89c5ac28105680f7f45e.svg";